import * as types from '../mutation-types'
import { lazyLoading } from './lazyLoading'

const state = {
  items: [
    {
      name: 'Project',
      path: '/',
      // meta: {icon: 'fa-circle-thin'},
      component: require('../../views/index')
    },

    {
      name: 'Edit Nodes',
      path: '/assets-edit',
      // meta: {icon: 'fa-circle-thin'},
      component: lazyLoading('assets-edit')
    },

    {
      name: 'Export',
      path: '/assets-export',
      // meta: {icon: 'fa-circle-thin'},
      component: lazyLoading('assets-export')
    }
  ]
}

const mutations = {
  [types.EXPAND_MENU] (state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js